export default async ({ store, route, redirect }) => {
  const videoID = route.params.id;
  await store.dispatch('video/getVideo', videoID);
  const { video } = store.state.video;
  if (video.status !== 'approve') {
    return redirect(`/space/${video.spaceID}/video`);
  }
};
